import React from 'react';
import ExternalAppTemplate from '../Pipedream/ExternalAppTemplate';
import { EXTERNAL_APP_CAPABILITIES } from '../Pipedream/externalAppCapability';

const TriggerFromExternalTemplate = (props) => (
  <ExternalAppTemplate {...props} capabilityConfig={EXTERNAL_APP_CAPABILITIES.trigger} />
);

export default TriggerFromExternalTemplate;
